module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navigation-desktop",
    class: {
      'navigation-desktop--active': _vm.$store.state.nav
    }
  }, [_c('div', {
    staticClass: "navigation-desktop__container"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('div', {
    staticClass: "navigation-desktop__logo",
    class: {
      'navigation-desktop__logo--active': _vm.$store.state.nav
    }
  }, [_c('Icon', {
    attrs: {
      "name": "logo"
    }
  })], 1)]), _c('div', {
    staticClass: "navigation-desktop__links"
  }, [_vm._l((_vm.props), function(nav) {
    return (nav.navigation) ? _c('div', {
      staticClass: "navigation-desktop__link"
    }, [_c('router-link', {
      attrs: {
        "to": nav.path
      }
    }, [_c('a', [_vm._v(_vm._s(nav.name))])])], 1) : _vm._e()
  }), _c('div', {
    staticClass: "navigation-desktop__link-box"
  }, [_c('div', {
    staticClass: "navigation-desktop__link navigation-desktop__link--option openchair-widget"
  }, [_c('Icon', {
    attrs: {
      "name": "calendar"
    }
  }), _vm._v("Appointment Link")], 1), _c('br'), _c('div', {
    staticClass: "navigation-desktop__link navigation-desktop__link--option customphonebtn"
  }, [_c('div', {
    staticClass: "navigation-desktop__custombtnlink",
    attrs: {
      "id": "custombntlink",
      "onclick": "openLocation()"
    }
  }, [_c('Icon', {
    attrs: {
      "name": "phone"
    }
  }), _c('span', {
    staticClass: "btntext"
  }, [_vm._v("Call Us")])], 1), _vm._m(0)])])], 2)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navigation-desktop__location_list",
    attrs: {
      "id": "custombntlinkopen"
    }
  }, [_c('a', {
    attrs: {
      "href": "tel:+17027354169"
    }
  }, [_vm._v("Eastern")]), _c('a', {
    attrs: {
      "href": "tel:+17023645100"
    }
  }, [_vm._v("Summerlin")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e1d2fb8","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/navigation/navigation-desktop/navigation-desktop.pug
// module id = 600
// module chunks = 1